export default class CountryPhone {
    public name!: string;
    public phoneMask!: string;

    constructor(name:string, phoneMask: string) {
        this.name = name;
        this.phoneMask = phoneMask;
    }
}